/* P0015 bolsa de lavado para tenis CASENA : comportements partagés des 4 pages (listicle, advertorial, ventas, compra).
   Chargé uniquement par les templates P0015. Chaque module est idempotent et s'accroche à des attributs data-p15-*. */
(function () {
  if (window.__p15) return;
  window.__p15 = 1;
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  function pad(n) { return String(n).padStart(2, '0'); }
  function each(sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); }

  /* Compte à rebours jusqu'à minuit (heure locale), comme la source */
  function countdown() {
    var els = document.querySelectorAll('[data-p15-countdown]');
    if (!els.length) return;
    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var d = Math.floor(s / 86400), h = Math.floor(s / 3600) % 24, m = Math.floor(s / 60) % 60, sec = s % 60;
      els.forEach(function (el) {
        var map = { d: d, h: h, m: m, s: sec };
        el.querySelectorAll('[data-u]').forEach(function (u) { u.textContent = pad(map[u.getAttribute('data-u')]); });
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* Minuteur de réservation du panier (10 min), comme le checkout source */
  function reserve() {
    var els = document.querySelectorAll('[data-p15-reserve]');
    if (!els.length) return;
    var total = 600, key = 'p15-reserve-start', start;
    try { start = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (e) { start = 0; }
    if (!start || Date.now() - start > total * 1000) {
      start = Date.now();
      try { sessionStorage.setItem(key, String(start)); } catch (e) {}
    }
    function tick() {
      var left = Math.max(0, total - Math.floor((Date.now() - start) / 1000));
      els.forEach(function (el) { el.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60); });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* Date d'expédition = aujourd'hui + 2 jours, en espagnol du Mexique */
  function shipdate() {
    var d = new Date();
    d.setDate(d.getDate() + 2);
    var CORTO = ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'sept.', 'oct.', 'nov.', 'dic.'];
    var txt = d.getDate() + ' de ' + MESES[d.getMonth()] + ' de ' + d.getFullYear();
    var corto = d.getDate() + ' de ' + CORTO[d.getMonth()];
    var num = pad(d.getDate()) + '/' + pad(d.getMonth() + 1);
    each('[data-p15-shipdate]', function (el) {
      var f = el.getAttribute('data-p15-shipdate');
      el.textContent = f === 'num' ? num : (f === 'short' ? corto : txt);
    });
  }

  /* Barre de progression de lecture (listicle) */
  function progress() {
    var bars = document.querySelectorAll('[data-p15-progress]');
    if (!bars.length) return;
    function upd() {
      var st = document.documentElement.scrollTop || document.body.scrollTop;
      var sh = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      var p = sh > 0 ? Math.min(st / sh * 100, 98.0066) : 0;
      bars.forEach(function (b) { b.style.width = p + '%'; });
    }
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  /* En-tête qui se replie après 80 px de défilement (listicle) */
  function collapse() {
    each('[data-p15-collapse]', function (row) {
      var hidden = false;
      function upd() {
        var y = window.scrollY;
        if (y > 80 && !hidden) { row.classList.add('is-collapsed'); hidden = true; }
        else if (y <= 80 && hidden) { row.classList.remove('is-collapsed'); hidden = false; }
      }
      window.addEventListener('scroll', upd, { passive: true });
      upd();
    });
  }

  /* Barre d'achat collante : visible une fois le premier bouton de la page sorti de l'écran */
  function stickyAfter() {
    each('[data-p15-sticky]', function (bar) {
      var rule = bar.getAttribute('data-p15-sticky') || '[data-p15-anchor]';
      var px = rule.indexOf('px:') === 0 ? parseInt(rule.slice(3), 10) : null;
      var anchor = px === null ? document.querySelector(rule) : null;
      var hideNear = bar.getAttribute('data-p15-sticky-hide');
      var near = hideNear ? document.querySelectorAll(hideNear) : [];
      function upd() {
        var show;
        if (px !== null) { show = window.scrollY > px; }
        else if (anchor) { var r = anchor.getBoundingClientRect(); show = r.bottom < 0; }
        else { show = window.scrollY > 600; }
        if (show) {  /* un bloc d'achat de la page est à l'écran : pas de 2e bouton */
          for (var i = 0; i < near.length; i++) {
            var nr = near[i].getBoundingClientRect();
            if (nr.top < window.innerHeight && nr.bottom > 0) { show = false; break; }
          }
        }
        bar.classList.toggle('is-on', !!show);
        document.body.classList.toggle('p15-sticky-on', !!show);
      }
      window.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* Défilant infini : on duplique les vignettes (source : 20 s linéaire, sens inverse) */
  function marquee() {
    each('[data-p15-marquee]', function (track) {
      if (track.dataset.dup) return;
      track.dataset.dup = '1';
      Array.prototype.slice.call(track.children).forEach(function (c) {
        var k = c.cloneNode(true);
        k.setAttribute('aria-hidden', 'true');
        k.querySelectorAll('img').forEach(function (i) { i.alt = ''; });
        track.appendChild(k);
      });
    });
  }

  /* Galerie : image principale + miniatures + flèches (preV1 et page d'achat) */
  function gallery() {
    each('[data-p15-gallery]', function (g) {
      if (g.dataset.init) return;
      g.dataset.init = '1';
      var slides = g.querySelectorAll('[data-slide]'), thumbs = g.querySelectorAll('[data-thumb]'), i = 0;
      if (!slides.length) return;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          if (k === i && t.scrollIntoView && t.parentElement && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
            t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
          }
        });
      }
      g.addEventListener('click', function (e) {
        var t = e.target.closest('[data-thumb]');
        if (t) { go(parseInt(t.getAttribute('data-thumb'), 10)); return; }
        if (e.target.closest('[data-prev]')) go(i - 1);
        if (e.target.closest('[data-next]')) go(i + 1);
      });
      var x0 = null;
      var stage = g.querySelector('[data-stage]') || g;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
        x0 = null;
      });
      go(0);
    });
  }

  /* Accordéons (FAQ) : délégation sur document, le premier est ouvert comme la source */
  function faq() {
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-p15-q]');
      if (!q) return;
      var item = q.closest('[data-p15-faq-item]');
      if (!item) return;
      var open = item.classList.toggle('is-open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Vidéos muettes en boucle : chargement et lecture à l'approche de l'écran */
  function lazyVideos() {
    var vs = document.querySelectorAll('video[data-p15-video]:not([data-armed])');
    if (!vs.length) return;
    function arm(v) {
      v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.getAttribute('data-src'); });
      v.muted = true;
      v.load();
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { vs.forEach(arm); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); arm(e.target); } });
    }, { rootMargin: '120% 0px' });
    vs.forEach(function (v) { v.dataset.armed = '1'; io.observe(v); });
  }

  /* Page d'achat : choix du paquet, couleur, résumé, ajout au panier puis paiement */
  function buy() {
    var root = document.querySelector('[data-p15-buy]');
    if (!root) return;
    var data;
    try { data = JSON.parse(root.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    var color = data.defaultColor, pack = data.defaultPack;
    function render() {
      root.querySelectorAll('[data-pack]').forEach(function (row) {
        var on = row.getAttribute('data-pack') === pack;
        row.classList.toggle('is-selected', on);
        var r = row.querySelector('input[type="radio"]');
        if (r) r.checked = on;
      });
      root.querySelectorAll('[data-color-img]').forEach(function (img) {
        var p = img.getAttribute('data-color-img');
        img.src = data.images[p + '|' + color];
        img.alt = data.alts[p + '|' + color];
      });
      root.querySelectorAll('[data-color-name]').forEach(function (el) { el.textContent = data.colorNames[color]; });
      root.querySelectorAll('[data-color-pick]').forEach(function (b) {
        var on = b.getAttribute('data-color-pick') === color;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var key = pack + '|' + color, v = data.variants[key];
      document.querySelectorAll('[data-sum-img]').forEach(function (i) { i.src = data.images[key]; i.alt = data.alts[key]; });
      document.querySelectorAll('[data-sum-name]').forEach(function (el) { el.textContent = data.labels[pack] + ' (' + data.colorNames[color] + ')'; });
      document.querySelectorAll('[data-sum-prices]').forEach(function (el) { el.innerHTML = data.priceHtml[pack]; });
      document.querySelectorAll('[data-sum-total]').forEach(function (el) { el.textContent = v.total; });
      root.setAttribute('data-color', color);
    }
    root.addEventListener('click', function (e) {
      var cp = e.target.closest('[data-color-pick]');
      if (cp) {  /* choix de la couleur dans la ligne du paquet (comme la référence) */
        e.preventDefault();
        color = cp.getAttribute('data-color-pick');
        var pr = cp.closest('[data-pack]');
        if (pr) pack = pr.getAttribute('data-pack');
        render();
        return;
      }
      var row = e.target.closest('[data-pack]');
      if (row) { pack = row.getAttribute('data-pack'); render(); return; }
      if (e.target.closest('[data-change-color]')) {
        e.preventDefault();
        color = color === data.colors[0] ? data.colors[1] : data.colors[0];
        render();
      }
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sum-toggle]');
      if (t) {
        var box = document.querySelector('[data-sum-box]');
        if (box) {
          var open = box.classList.toggle('is-open');
          t.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        return;
      }
      var ap = e.target.closest('[data-apply-code]');
      if (ap) {
        e.preventDefault();
        var inp = document.querySelector('[data-code-input]');
        var msg = document.querySelector('[data-code-msg]');
        var code = inp ? inp.value.trim() : '';
        try { sessionStorage.setItem('p15-code', code); } catch (err) {}
        if (msg) msg.textContent = code ? data.codeMsg.replace('{code}', code) : '';
        return;
      }
      var go = e.target.closest('[data-p15-checkout]');
      if (!go) return;
      e.preventDefault();
      if (go.getAttribute('aria-busy') === 'true') return;
      go.setAttribute('aria-busy', 'true');
      /* Lien de paiement direct Shopify (/cart/variante:1) : le checkout s'ouvre avec ce seul paquet, sans passer par le
         panier, donc sans le tiroir UpCart (qui réagit à /cart/add.js) ni les articles d'une visite précédente. */
      var key = pack + '|' + color, code = '';
      try { code = sessionStorage.getItem('p15-code') || ''; } catch (err) {}
      window.location.href = '/cart/' + data.variants[key].id.toString() + ':1' + (code ? '?discount=' + encodeURIComponent(code) : '');
    });
    render();
  }

  /* Apparitions au défilement (fondu montant), seulement si le mouvement est autorisé */
  function reveal() {
    if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = document.querySelectorAll('[data-p15-reveal]');
    if (!els.length) return;
    els.forEach(function (el) { el.style.opacity = '0'; });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.animate([{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }], { duration: 450, easing: 'ease-out', fill: 'forwards' });
        e.target.style.opacity = '';
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Date du jour au format mexicain jj/mm/aa (encadré « Al … » de l'advertorial) */
  function today() {
    var d = new Date();
    var txt = pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + String(d.getFullYear()).slice(-2);
    each('[data-p15-today]', function (el) { el.textContent = txt; });
  }

  function init() {
    today(); countdown(); reserve(); shipdate(); progress(); collapse(); stickyAfter(); marquee(); gallery(); faq(); lazyVideos(); buy(); reveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
